/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllingMonthlyEmployeeRevenueTargets } from '../models/ControllingMonthlyEmployeeRevenueTargets';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingMonthlyEmployeeRevenueTargetsService {
    /**
     * upload monthly targets
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateControllingMonthlyEmployeeRevenueTargets(
        requestBody?: ControllingMonthlyEmployeeRevenueTargets,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/controlling/monthly_employee_revenue_targets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad request for invalid row`,
            },
        });
    }
    /**
     * export monthly employee revenue targets as csv
     * @param tenantId tenant_id
     * @param year year
     * @returns binary successfully sends export data
     * @throws ApiError
     */
    public static export(
        tenantId: string,
        year?: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/monthly_employee_revenue_targets/export',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
            },
        });
    }
}
